<template>
	<div>
		<Slider
			:id="context.id"
			:value="context._value"
			:min="context.min"
			:max="context.max"
			:step="context.step"
			:tooltips="false"
			:classes="{
				target: 'relative box-border select-none touch-none tap-highlight-transparent touch-callout-none disabled:cursor-not-allowed',
				focused: 'slider-focused',
				tooltipFocus: 'slider-tooltip-focus',
				tooltipDrag: 'slider-tooltip-drag',
				ltr: 'slider-ltr',
				rtl: 'slider-rtl',
				horizontal: 'slider-horizontal h-1.5',
				vertical: 'slider-vertical w-1.5 h-80',
				textDirectionRtl: 'slider-txt-rtl',
				textDirectionLtr: 'slider-txt-ltr',
				base: 'w-full h-full relative z-1 bg-background-secondary rounded-sm',
				connects: 'w-full h-full relative overflow-hidden z-0 rounded-sm',
				connect: 'absolute z-1 top-0 right-0 transform-origin-0 transform-style-flat h-full w-full bg-background-important cursor-pointer tap:duration-300 tap:transition-transform disabled:bg-background-disabled disabled:cursor-not-allowed',
				origin: 'slider-origin absolute z-1 top-0 right-0 transform-origin-0 transform-style-flat h-full w-full h:h-0 v:-top-full txt-rtl-h:left-0 txt-rtl-h:right-auto v:w-0 tap:duration-300 tap:transition-transform',
				handle: 'absolute rounded-full bg-background-important border-0 cursor-grab focus-outline h:w-6 h:h-6 h:-top-2.5 h:-right-2 txt-rtl-h:-left-2 txt-rtl-h:right-auto v:w-4 v:h-4 v:-top-2 v:-right-1.25 disabled:cursor-not-allowed',
				handleLower: 'slider-hande-lower',
				handleUpper: 'slider-hande-upper',
				touchArea: 'h-full w-full',
				tooltip: 'absolute block typo-body-s font-semibold whitespace-nowrap py-1 px-1.5 min-w-5 text-center text-body-inverse rounded-sm bg-background-important transform h:-translate-x-1/2 h:left-1/2 v:-translate-y-1/2 v:top-1/2 disabled:bg-background-disabled merge-h:translate-x-1/2 merge-h:left-auto merge-v:-translate-x-4 merge-v:top-auto tt-focus:hidden! tt-focused:block! tt-drag:hidden! tt-dragging:block!',
				tooltipTop: 'bottom-6 h:arrow-bottom merge-h:bottom-3.5',
				tooltipBottom: 'top-6 h:arrow-top merge-h:top-5',
				tooltipLeft: 'right-6 v:arrow-right merge-v:right-1',
				tooltipRight: 'left-6 v:arrow-left merge-v:left-7',
				tooltipHidden: 'slider-tooltip-hidden',
				active: 'slider-active shadow-slider-active cursor-grabbing',
				draggable: 'cursor-ew-resize v:cursor-ns-resize',
				tap: 'slider-state-tap',
				drag: 'slider-state-drag',
			}"
			@slide="handleSlide"
			@change="hadleChange"
		/>
		<ClientOnly>
			<div class="flex justify-between typo-body-s mt-3">
				<span v-text="$n(currentMin, 'currency')" />
				<span v-text="$n(currentMax, 'currency')" />
			</div>
		</ClientOnly>
	</div>
</template>
<script setup lang="ts">
	import Slider from '@vueform/slider';
	import {set} from '@vueuse/core';
	import type {SliderContext} from '~/types/formkitSlider';

	interface Props {
		context: SliderContext
	}

	const props = defineProps<Props>();

	const currentMin = ref<number>(props.context.min);
	const currentMax = ref<number>(props.context.max);
	const handleSlide = (value: SliderContext['_value']) => {
		const [min, max] = value;
		set(currentMin, min);
		set(currentMax, max);
	};

	handleSlide(props.context._value);

	const hadleChange = (value: SliderContext['_value']) => {
		props.context.node.input(value);
	};
</script>
